import React, { useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import useScreenSize from 'Hooks/useScreenSize';

// DS
import {
  VertCarousel,
  VertContainer,
  } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/CategoryChipsMenu/CategoryChipsMenuStyles.less';
import {  useDispatch, useSelector } from 'react-redux';
import CategoryPlaceholder from './CategoryPlaceholder';
import { useCategoryPage } from '../../pages/CategoryPage/CategoryPageProvider';
import { getCategoriesChips } from 'redux/Reducers/CategoriesChips/CategoriesChipsReducer';

const carouselSettings = ({ items: itemsProps, screenSize }) => {
  const items = itemsProps || [];
  const configProps = () => {
    if (screenSize <= 380) {
      return {
        arrows: items.length > 2,
        slidesToShow: items.length > 2 ? 2 : items.length,
        infinite: true,
      };
    }

    if (screenSize <= 480) {
      return {
        arrows: items.length > 3,
        infinite: true,
        slidesToShow: items.length > 3 ? 3 : items.length,
      };
    }
    if (screenSize <= 576) {
      return {
        arrows: items.length > 3,
        slidesToShow: items.length > 3 ? 3 : items.length,
      };
    }
    if (screenSize <= 768) {
      return {
        arrows: items.length > 4,
        slidesToShow: 4,
        infinite: true,
      };
    }
    if (screenSize <= 992) {
      return {
        arrows: items.length > 5,
        slidesToShow: items.length > 5 ? 5 : 4,
      };
    }
    if (screenSize <= 1200) {
      return {
        arrows: items.length > 6,
        slidesToShow: items.length > 6 ? 6 : items.length,
      };
    }
    if (screenSize >= 1201 && screenSize <= 1600) {
      return {
        arrows: items.length > 8,
        slidesToShow: items.length > 8 ? 9 : items.length,
      };
    }

    if (screenSize < 1600) {
      return {
        arrows: items.length > 8,
        slidesToShow: items.length > 8 ? 10 : items.length,
      };
    }
    return {
      arrows: items.length > 8,
      infinite: true,
      slidesToShow: items.length > 8 ? 10 : items.length,
    };
  };
  return {
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    ...configProps(),
  };
};

const CategoryChipsMenu = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { screenWidth } = useScreenSize();
  const params = useParams();
  const { title: titleCategoryPage, setTitle: setTitleCategoryPage } = useCategoryPage();
  const CategoryItems = useSelector(({ CategoriesChips }) => CategoriesChips);

  
  useEffect(() => {
    dispatch(getCategoriesChips());
  
  }, []);

  

  useEffect(() => {
    if (CategoryItems && CategoryItems?.items?.length && params && params.id) {
      const { id: categoryId } = params;
      const filteredItems = CategoryItems.items.filter(
        ({ id }) => categoryId == id
      );
      if (filteredItems.length > 0) {
        const categoryName = filteredItems[0].name;
        if (titleCategoryPage !== categoryName) {
          setTitleCategoryPage(categoryName);
        }
      }
    }
  }, [titleCategoryPage, params, CategoryItems]);

  if (!CategoryItems || CategoryItems.isLoading) return <CategoryPlaceholder />;

  const checkIfCategorieIsChecked = (id) => {
    const Rx = new RegExp(`^(/category/${id})/`);
    if (location && Rx.test(location.pathname)) {
      return true;
    }
    return false;
  };

  const items = Array.isArray(CategoryItems.items) ? CategoryItems.items.map((item, index) => {
    return (
      <div className="category-item" key={`${item.id}-categoryItem-${index}`}>
        <Link
          className={checkIfCategorieIsChecked(item.id) ? 'active' : ''}
          to={`/category/${item.id}/1`}
        >
          {item.name}
        </Link>
      </div>
    );
  }) : [];
  

  return (
    <VertContainer
      className="vert-box-chips margin-bottom-regular"
      spacingX="regular"
    >
      <div className="category-chips-menu-container">
        <div className="category-chips-menu-content">
          <VertCarousel
            variableWidth
            {...carouselSettings({
              items: CategoryItems.items,
              screenSize: screenWidth,
             
            })}
          >
            {items}
          </VertCarousel>
        </div>
      </div>
    </VertContainer>
  );
};

export default CategoryChipsMenu;
